export default {
  SET_CURRENT_MANAGER(state, manager) {
    state.manager = manager
  },
}
